import PropTypes from 'prop-types'
import { forwardRef } from 'react'

const SVG = forwardRef(({ width, height, ...rest }, ref) => (
  <svg
    ref={ref}
    preserveAspectRatio="xMinYMin meet"
    viewBox={`0 0 ${width} ${height}`}
    {...rest}
  />
))

SVG.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
}

SVG.displayName = 'SVG'

export default SVG
